import moment from 'moment';
const EVENT_TRACKING_NAME = 'maintenanceAssetModal';
const EVENT_TRACKING_ACTIONS = {
  calculateByDate: 'calculateByDate',
  calculateByHistorical: 'calculateByHistorical',
  cancelClicked: 'cancelClicked',
  confirmClicked: 'confirmClicked',
};

const addToDataLayer = (data) => {
  window.dataLayer.push({
    event: EVENT_TRACKING_NAME,
    data: { ...data }
  });
} 

export default ($scope, $uibModalInstance, selected, equipmentDetailsService, gettextCatalog, $q) => {
  'ngInject';

  $scope.initialization = '';
  $scope.addedAssets = [];
  $scope.defaultServiceDate = moment().toDate();
  $scope.loadingServiceReadings = true;
  $scope.selectedAssets = selected;

  const buildAssetWithServiceReading = asset => {
    const runtime = asset.onei3.series.run_time ? asset.onei3.series.run_time.last : undefined;

    return $q.when({
      asset: {
        id: asset.id,
        name: asset.name
      },
      serviceReading: {
        odometer: asset.onei3.series.odometer ? parseInt(asset.onei3.series.odometer.last.v) : 0,
        runhour: runtime ? parseInt(asset.onei3.series.run_time.last.v) : 0,
        date: runtime ? moment(asset.onei3.series.run_time.last.t).toDate() : moment().toDate()
      }
    });
  };

  const setupServiceReadings = selected => {
    const fetchServiceReadingsPromises = [];

    selected.added.forEach(added => {
      const promise = equipmentDetailsService
        .get(added, ['series'], null)
        .then(buildAssetWithServiceReading)
        .then(asset => $scope.addedAssets.push(asset));

      fetchServiceReadingsPromises.push(promise);
    });

    $q.all(fetchServiceReadingsPromises)
      .catch(() => {
        $scope.errorText = gettextCatalog.getString('An error occurred while retrieving timeseries data');
        $scope.errorFlag = true;
        $scope.loadingServiceReadings = false;
      })
      .finally(() => {
        $scope.loadingServiceReadings = false;
      });
  };

  setupServiceReadings(selected);
  $scope.updateModelForDefaultServiceDate = function(date) {
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.calculateByDate,
      date: date,
    });
    $scope.defaultServiceDate = date;
  };

  $scope.setDateForAllChecked = function(checked) {
    $scope.setMaintenanceDateForAll = checked;
  };

  $scope.ok = function() {
    addToDataLayer({
      event: EVENT_TRACKING_ACTIONS.confirmClicked,
    });

    $scope.addedAssets.forEach(asset => {
      //max value for integer = 2147483647
      if (
        asset.serviceReading.odometer > 2147483647 ||
        asset.serviceReading.odometer === undefined ||
        asset.serviceReading.runhour > 2147483647 || asset.serviceReading.runhour === undefined
      ) {
        $scope.errorText = gettextCatalog.getString(
          'Odometer or Run Hours number is too large. Please ensure the Odometer and Run Hours are below 2,147,483,647'
        );
        $scope.errorFlag = true;
        e.preventDefault();
      }
    });

    $uibModalInstance.close({
      assets: $scope.addedAssets,
      setDateForAll: $scope.initialization === 'date',
      defaultServiceDate: $scope.defaultServiceDate,
      selectedAssets: $scope.selectedAssets
    });
  };

  $scope.cancel = function() {
    addToDataLayer({
      event: EVENT_TRACKING_ACTIONS.cancelClicked,
    });

    $uibModalInstance.dismiss('cancel');
  };
  $scope.$on('$locationChangeStart', function(event) {
    $scope.cancel();
    event.preventDefault();
  });

  $scope.calculateByDateClicked = () => {
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.calculateByDate,
      clicked: true,
    });
  }

  $scope.calculateByHistoricalClicked = () => {
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.calculateByHistorical,
      clicked: true,
    });
  }

  $scope.historicalAssetDateChanged = (asset) => {
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.calculateByHistorical,
      dateChanged: true,
      assetId: asset?.asset?.id
    });
  }

  $scope.historicalAssetOdometerChanged = (asset ) => {
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.calculateByHistorical,
      odomoterChanged: asset.serviceReading?.odometer,
      assetId: asset?.asset?.id
    });
  }

  $scope.historicalAssetRunhourChanged = (asset) => {
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.calculateByHistorical,
      runhourChanged: asset.serviceReading?.runhour,
      assetId: asset?.asset?.id
    });
  }
};
